import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/properties';

const namespace = 'PROPERTIES';

export const FETCH_PROPERTY_START = `${namespace}/FETCH_PROPERTY_START`;
export const FETCH_PROPERTY_SUCCESS = `${namespace}/FETCH_PROPERTY_SUCCESS`;
export const FETCH_PROPERTY_ERROR = `${namespace}/FETCH_PROPERTY_ERROR`;

export const fetchProperty = makeApiActionCreatorV3(
  api.fetchProperty,
  FETCH_PROPERTY_START,
  FETCH_PROPERTY_SUCCESS,
  FETCH_PROPERTY_ERROR,
);

export const FETCH_PROPERTY_ASSOCIATION_START = `${namespace}/FETCH_PROPERTY_ASSOCIATION_START`;
export const FETCH_PROPERTY_ASSOCIATION_SUCCESS = `${namespace}/FETCH_PROPERTY_ASSOCIATION_SUCCESS`;
export const FETCH_PROPERTY_ASSOCIATION_ERROR = `${namespace}/FETCH_PROPERTY_ASSOCIATION_ERROR`;

export const fetchPropertyAssociations = makeApiActionCreatorV3(
  api.fetchPropertyAssociations,
  FETCH_PROPERTY_ASSOCIATION_START,
  FETCH_PROPERTY_ASSOCIATION_SUCCESS,
  FETCH_PROPERTY_ASSOCIATION_ERROR,
);

export const FETCH_TAXING_UNITS_START = `${namespace}/FETCH_TAXING_UNITS_START`;
export const FETCH_TAXING_UNITS_SUCCESS = `${namespace}/FETCH_TAXING_UNITS_SUCCESS`;
export const FETCH_TAXING_UNITS_ERROR = `${namespace}/FETCH_TAXING_UNITS_ERROR`;

export const fetchTaxingUnits = makeApiActionCreatorV3(
  api.fetchTaxingUnits,
  FETCH_TAXING_UNITS_START,
  FETCH_TAXING_UNITS_SUCCESS,
  FETCH_TAXING_UNITS_ERROR,
);

export const INSERT_PROPERTY_START = `${namespace}/INSERT_PROPERTY_START`;
export const INSERT_PROPERTY_SUCCESS = `${namespace}/INSERT_PROPERTY_SUCCESS`;
export const INSERT_PROPERTY_ERROR = `${namespace}/INSERT_PROPERTY_ERROR`;

export const insertProperty = makeApiActionCreatorV3(
  api.insertProperty,
  INSERT_PROPERTY_START,
  INSERT_PROPERTY_SUCCESS,
  INSERT_PROPERTY_ERROR,
);

export const INSERT_PROPERTY_ASSOCIATION_START = `${namespace}/INSERT_PROPERTY_ASSOCIATION_START`;
export const INSERT_PROPERTY_ASSOCIATION_SUCCESS = `${namespace}/INSERT_PROPERTY_ASSOCIATION_SUCCESS`;
export const INSERT_PROPERTY_ASSOCIATION_ERROR = `${namespace}/INSERT_PROPERTY_ASSOCIATION_ERROR`;

export const insertPropertyAssociation = makeApiActionCreatorV3(
  api.insertPropertyAssociation,
  INSERT_PROPERTY_ASSOCIATION_START,
  INSERT_PROPERTY_ASSOCIATION_SUCCESS,
  INSERT_PROPERTY_ASSOCIATION_ERROR,
);

export const DELETE_PROPERTY_ASSOCIATION_START = `${namespace}/DELETE_PROPERTY_ASSOCIATION_START`;
export const DELETE_PROPERTY_ASSOCIATION_SUCCESS = `${namespace}/DELETE_PROPERTY_ASSOCIATION_SUCCESS`;
export const DELETE_PROPERTY_ASSOCIATION_ERROR = `${namespace}/DELETE_PROPERTY_ASSOCIATION_ERROR`;

export const deletePropertyAssociation = makeApiActionCreatorV3(
  api.deletePropertyAssociation,
  DELETE_PROPERTY_ASSOCIATION_START,
  DELETE_PROPERTY_ASSOCIATION_SUCCESS,
  DELETE_PROPERTY_ASSOCIATION_ERROR,
);

export const UPDATE_PROPERTY_START = `${namespace}/UPDATE_PROPERTY_START`;
export const UPDATE_PROPERTY_SUCCESS = `${namespace}/UPDATE_PROPERTY_SUCCESS`;
export const UPDATE_PROPERTY_ERROR = `${namespace}/UPDATE_PROPERTY_ERROR`;

export const updateProperty = makeApiActionCreatorV3(
  api.updateProperty,
  UPDATE_PROPERTY_START,
  UPDATE_PROPERTY_SUCCESS,
  UPDATE_PROPERTY_ERROR,
);

export const UPDATE_PROPERTY_TAXING_UNITS_START = `${namespace}/UPDATE_PROPERTY_TAXING_UNITS_START`;
export const UPDATE_PROPERTY_TAXING_UNITS_SUCCESS = `${namespace}/UPDATE_PROPERTY_TAXING_UNITS_SUCCESS`;
export const UPDATE_PROPERTY_TAXING_UNITS_ERROR = `${namespace}/UPDATE_PROPERTY_TAXING_UNITS_ERROR`;

export const updatePropertyTaxingUnits = makeApiActionCreatorV3(
  api.updatePropertyTaxingUnits,
  UPDATE_PROPERTY_TAXING_UNITS_START,
  UPDATE_PROPERTY_TAXING_UNITS_SUCCESS,
  UPDATE_PROPERTY_TAXING_UNITS_ERROR,
);

export const SET_FINAL_VALUE_START = `${namespace}/SET_FINAL_VALUE_START`;
export const SET_FINAL_VALUE_SUCCESS = `${namespace}/SET_FINAL_VALUE_SUCCESS`;
export const SET_FINAL_VALUE_ERROR = `${namespace}/SET_FINAL_VALUE_ERROR`;

export const setFinalValue = makeApiActionCreatorV3(
  api.setFinalValue,
  SET_FINAL_VALUE_START,
  SET_FINAL_VALUE_SUCCESS,
  SET_FINAL_VALUE_ERROR,
);

export const SET_OPINION_VALUE_START = `${namespace}/SET_OPINION_VALUE_START`;
export const SET_OPINION_VALUE_SUCCESS = `${namespace}/SET_OPINION_VALUE_SUCCESS`;
export const SET_OPINION_VALUE_ERROR = `${namespace}/SET_OPINION_VALUE_ERROR`;

export const setOpinionValue = makeApiActionCreatorV3(
  api.setOpinionValue,
  SET_OPINION_VALUE_START,
  SET_OPINION_VALUE_SUCCESS,
  SET_OPINION_VALUE_ERROR,
);
